<template>
  <div class="SuccessfulPayment">
    <div>
      <p><img src="./image/success.png" alt="image" /></p>
      <p>支付成功</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessfulPayment',
};
</script>

<style scoped lang="less">
.SuccessfulPayment {
  text-align: center;
  font-size: 24px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  width: 200px;
  height: 100vh;
  margin: 0 auto;
}
</style>
